// don't go to parent menu-item on click
const parents = document.querySelectorAll('.menu-item-has-children > a');
for (let i = 0; i < parents.length; i++) {
	parents[i].addEventListener('click', (e) => e.preventDefault());
}

const toggle = document.querySelector('.menu-toggle');
const nav = document.querySelector('.main-navigation');
toggle.addEventListener('click', () => nav.classList.toggle('toggled'));